import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56a8c43c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "welcome-wrapper" }
const _hoisted_2 = { class: "welcome-inner" }
const _hoisted_3 = { class: "has-text-centered mb-4 mt-10" }
const _hoisted_4 = { class: "has-text-centered" }
const _hoisted_5 = { class: "has-text-centered" }
const _hoisted_6 = {
  "data-testid": "welcome-video",
  class: "video-bg",
  autoplay: "",
  muted: ""
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "mx-6" }
const _hoisted_9 = { class: "have-profile mt-4" }

import { useRouter } from 'vue-router'
import { ref } from 'vue'

import Animation from '@/assets/videos/animation01.mp4'
import Button from '@/popup/components/shared/Button.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Welcome',
  setup(__props) {

const router = useRouter()
const animation = ref(Animation)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('welcome.title')), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('welcome.secure')), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('welcome.up_extension')), 1 /* TEXT */),
      _createElementVNode("video", _hoisted_6, [
        _createElementVNode("source", {
          src: animation.value,
          type: "video/mp4"
        }, null, 8 /* PROPS */, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(Button, {
          variant: "primary",
          "data-testid": "get-started-button",
          "is-full-width": true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/terms-of-use')))
        }, {
          default: _withCtx(() => [
            _createVNode(SvgIcon, {
              class: "mr-2",
              name: "profile-add",
              color: "var(--neutral-100)",
              width: "24",
              height: "24"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('welcome.get_started')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('welcome.have_profile')), 1 /* TEXT */)
      ])
    ])
  ]))
}
}

})